import { useLang } from 'hooks/lang';

import { Row, Column } from 'components/Blocks';
import { CircleCheckIcon, WarningIcon } from 'components/Icons';

import { SelectPaymentButton } from './SelectPaymentButton';
import { PaymentInfoDisplay } from './PaymentInfoDisplay';

import { useProjectProfile } from 'pages/Projects/ProjectProfile/context';
import { useUser } from 'hooks/user';
import { cn } from 'styles';

export function PaymentMethod() {
  const {
    project: { invoice },
  } = useProjectProfile();

  const user = useUser();

  const { t } = useLang();

  const isSelected = !!invoice.type;

  const isInvoiceOwner = [invoice.owner.id, invoice.subOwner?.id].some((id) => id === user.id);

  const invoiceType = {
    STANDARD: t('standard'),
    PACKAGE: t('package'),
  };

  const { Icon, title, message, className } = isSelected
    ? {
        Icon: <CircleCheckIcon color="success" />,
        title: `${t('project-payment-method-defined')}`,
        message: '',
        className: 'border border-success bg-success-light/10',
      }
    : {
        Icon: <WarningIcon color="warning" />,
        title: t('payment-method-is-missing'),
        message: t(
          isInvoiceOwner
            ? 'click-the-button-below-to-select-the-payment-method'
            : 'payment-method-not-selected',
        ),
        className: 'border border-warning',
      };

  return (
    <Column className={cn(className, 'w-full max-w-[400px] shrink-0 rounded-lg p-6')}>
      <Row gap="2.5">
        {Icon}

        <span className="font-semibold">{title}</span>
      </Row>

      {message && <span className="text-sm">{message}</span>}

      {isSelected && (
        <div className="mx-auto w-fit rounded-md border border-success px-2 py-1 font-semibold text-success">
          {invoiceType[invoice.type!]}
        </div>
      )}

      <SelectPaymentButton />

      <PaymentInfoDisplay />
    </Column>
  );
}
